export { default } from "./IconWrapper";
